import CurriculumTable from './CurriculumTable';

export default CurriculumTable;
